import type { ComponentProps } from 'react';
import React from 'react';

import { useLocalization } from '../../providers/LocaleProvider';
import MovableButton from '../Button/MovableButton';
import Icon from '../Icon';
import type { useSearch } from './hooks';
import { trackSearchClear } from './utils/tracking';

const ICON_SIZE = 24;

interface SearchClearButtonProps {
  input: ReturnType<typeof useSearch>['input'];
  shopName?: string;
}

const CLEAR_BTN_HIDE_RIGHT = '-40px';

const iconStyles: Partial<ComponentProps<typeof Icon>> = {
  fill: 'sys.neutral.icon.default',
  size: ICON_SIZE,
};

const ClearButton = ({ input, shopName }: SearchClearButtonProps) => {
  const { t } = useLocalization();
  const clickHandler = () => {
    input.handlers.handleSearchClearClick();
    trackSearchClear(input.value, shopName);
  };

  return (
    <MovableButton
      data-testid="search-clear-button"
      hidden={input.flags.isClearButtonHidden}
      aria-label={t('h24_clear_search')}
      aria-hidden={input.flags.isClearButtonHidden}
      tabIndex={input.flags.isClearButtonHidden ? -1 : 0}
      hideToRight={CLEAR_BTN_HIDE_RIGHT}
      onClick={clickHandler}
    >
      <Icon name="close" dataTestId="search-clear-icon" {...iconStyles} />
    </MovableButton>
  );
};

export default ClearButton;
